import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IWizard } from 'src/app/interfaces/iwizard';
import { MarketingSource } from 'src/app/interfaces/MarketingSource/marketing-source';
import { MarketingSourceDetail } from 'src/app/interfaces/MarketingSource/marketing-source-detail';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { MarketingSourceService } from 'src/app/services/marketing-source.service';

@Component({
     selector: 'app-m-how',
     templateUrl: './m-how.component.html',
     styleUrls: ['./m-how.component.scss'],
     standalone: false
})
export class MHowComponent {
     companyInfo!: FormGroup;
     emailsTested: number = 0;
     pageReady: boolean = false;

     isLoading: boolean = true;
     marketingSources: MarketingSource[] = [];
     selectedDisplayItem: MarketingSource | null = null;
     marketingSourceDetails: MarketingSourceDetail[] = [];

     private _discoveredViaEditField: any;
     @Input()
     set _discoveredViaEdit(val: any) {
          this._discoveredViaEditField = val;
          this.companyInfo.patchValue({ discoveredVia: val });
     }
     get value(): any {
          return this._discoveredViaEditField;
     }
     get discoveredVia() { return this.companyInfo!.get('discoveredVia'); }

     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService,
          private _router: Router,
          public marketingSourceService: MarketingSourceService) {

          //we are going to double test all the emails here.
          // if there is a problem we will move the customer back to review
          this.enrollmentService.foundDupEmails = false;
          this.enrollmentService.testEmail(this.enrollmentService.powerUser!.email).subscribe((v: any) => {
               if (v === 'true') {
                    this.enrollmentService.foundDupEmails = true;
                    this._router.navigateByUrl('/signup/14');
               }
               if (this.enrollmentService.billingUserSame === "false") {
                    this.enrollmentService.testEmail(this.enrollmentService.billingUser!.email).subscribe((v: any) => {
                         if (v === 'true') {
                              this.enrollmentService.foundDupEmails = true;
                              this._router.navigateByUrl('/signup/14');
                         }
                    });
               }
               if (this.enrollmentService.users!.length > 0) {
                    this.emailsTested = 0
                    for (let i = 0; i < this.enrollmentService.users!.length; i++) {

                         this.enrollmentService.testEmail(this.enrollmentService.users![i].email).subscribe((v: any) => {
                              if (v === 'true') {
                                   this.enrollmentService.foundDupEmails = true;
                                   i = this.enrollmentService.users!.length;
                                   this._router.navigateByUrl('/signup/14');
                              } else {
                                   this.emailsTested++;
                                   if (this.emailsTested === this.enrollmentService.users!.length) {
                                        this.pageReady = true;
                                   }
                              }
                         });
                    };
               } else {
                    this.pageReady = true;
               }
          });
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit(): void {
          this.isLoading = true;
          this.loadMarketingSources();
          setTimeout(() => this.scrollToTop(), 500);
     }

     pageInvalid() {
          return this.companyInfo && this.companyInfo.invalid;
     }

     ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {
          this.enrollmentService.newCustomer!.discoveredPspVia = this.cleanDiscoveredViaFreeEntry(this.companyInfo!.get('discoveredVia')?.value);
          this.enrollmentService.saveToLocal();
     }

     loadMarketingSources(): any {
          const marketingSourcesDisplayPromise = this.marketingSourceService.getMarketingSources('customer');
          marketingSourcesDisplayPromise.subscribe((displayResult) => {
               this.marketingSources = displayResult;
               this.createForm();
               this.isLoading = false;
          });
     }

     private createForm() {
          this.companyInfo = new FormGroup({
               discoveredVia: new FormControl(this.enrollmentService.newCustomer!.discoveredPspVia, [
                    Validators.required
               ]),
          });
     }

     private cleanDiscoveredViaFreeEntry(entry: string | undefined): string {
          let valueToStore = '';
          if (entry && entry.includes('Other: ')) {
               const parts = entry.split(': ');
               const freeEntry = parts.pop();
               if (freeEntry) {
                    const regex = /[^a-zA-Z0-9\s]/g;
                    const cleanEntry = freeEntry.replace(regex, '');
                    parts.push(cleanEntry.toUpperCase());
               }
               valueToStore = parts.join(": ");
          } else if (entry) {
               valueToStore = entry;
          }
          return valueToStore;
     }
}
